import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class OIDCProvider implements ViewModel {
  readonly friendlyTypeNameSingular = 'User';
  readonly apiRoute: string = CONFIG.apiRoutes.ssoProviders;

  public authenticationSchemeName: string;
  public displayName: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.authenticationSchemeName = data.authenticationSchemeName;
    this.displayName = data.displayName;
  }
}
